<template>
  <show-layout>
    <template slot="header">
      <v-btn icon :to="{path: '/'}">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>

      <v-toolbar-title v-if="application.application_type">
        {{application.application_type.acronym}} - {{application.application_type.name}}
      </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn large color="white" class="success--text"
             :disabled="!canSendApplicationToReview()"
             @click="sendApplicationToReview">
        <v-icon left>mdi-send</v-icon>
        Enviar para análise
      </v-btn>
    </template>

    <template slot="sidebar">
      <qualification-form-dialog
          :show.sync="showQualificationForm"
          :qualification-form="application.qualification_form"
      />
      <v-layout column>
        <v-flex>
          <v-subheader class="subheader-1">
            Boleto do Requerimento
          </v-subheader>
          <boleto-card :payment_slip="getPaymentSlip({ complementary: false })"></boleto-card>
        </v-flex>

        <v-flex v-if="getPaymentSlip({ complementary: true })">
          <v-subheader class="subheader-1">
            Boleto de Complemento
          </v-subheader>
          <boleto-card :payment_slip="getPaymentSlip({ complementary: true })"></boleto-card>
        </v-flex>

        <v-flex>
          <v-subheader class="subheader-1">
            Requerimento
          </v-subheader>

          <v-card flat class="mb-2">
            <v-list>
              <v-list-tile>
                <v-layout column align-start justify-start>
                    ID: {{ application.id }}
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="application.folder_number">
                <v-layout column align-start justify-start>
                    Número: {{ application.folder_number }}
                </v-layout>
              </v-list-tile>
              <v-list-tile class="mb-1">
                <v-layout column align-start justify-start>
                  <span class="mb-2 subheader-2" v-if="application.application_type">
                    {{application.application_type.acronym}} -
                    {{application.application_type.name}}
                  </span>
                  <span class="badge" v-bind:style="this.applicationChipColor">
                    {{this.applicationChipText}}
                  </span>
                </v-layout>
              </v-list-tile>
              <v-list-tile v-if="application.qualification_form && application.qualification_form.length > 0">
                <v-layout column align-start justify-start>
                  <v-btn small color="primary" @click="openQualificationForm">
                    <v-icon small left>mdi-file-document</v-icon>
                    Formulário LAC
                  </v-btn>
                </v-layout>
              </v-list-tile>
            </v-list>
          </v-card>
        </v-flex>

        <v-flex>
          <v-subheader class="subheader-1">
            Tipologia
          </v-subheader>

          <v-card flat class="mb-2" v-if="application.typology">
            <v-card-text>
              <p>
                {{application.typology.code}} - {{application.typology.name}}
              </p>
              <p v-if="application.subject">
                Assunto:  {{application.subject}}
              </p>
              <p v-if="application.degrading_potential_for_tax">
                Potencial Degradador: {{application.degrading_potential_for_tax.name}}
              </p>
              <p v-if="application.size_for_tax">
                Porte:  {{application.size_for_tax.name}}
              </p>
              <p v-if="application.enviromental_study_type">
                Estudo Exigido:  {{application.enviromental_study_type.name}}
                ({{ application.enviromental_study_type.acronym }})
              </p>

            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex>
          <v-subheader class="subheader-1">
            Solicitante
          </v-subheader>

          <v-card flat class="mb-2">
            <v-list>
              <v-list-tile v-if="application.person">
                <v-layout row>
                  <v-icon class="mr-3">mdi-account</v-icon>
                  <v-layout column>
                    <span class="solicitante"> {{application.person.name}}</span>
                    <small class="grey--text">CPF: {{application.person.cpf_cnpj}}</small>
                  </v-layout>
                </v-layout>
              </v-list-tile>

              <v-divider class="my-2"/>

              <v-card flat class="px-3 py-2"  v-if="application.person.address">
                <v-layout column>
                  <small class="text-uppercase grey--text text--darken-1">
                    Endereço Residencial
                  </small>
                  <span>
                      {{application.person.address.street}},
                      {{application.person.address.number}} -
                      {{application.person.address.complement}} -
                      {{application.person.address.neighborhood}},
                      {{application.person.address.city}} -
                      {{application.person.address.state}}
                      {{application.person.address.zip_code}}
                    </span>
                </v-layout>
              </v-card>

              <v-divider class="my-2"/>

              <v-card flat class="px-3 py-2" v-if="application.address">
                <v-layout column>
                  <small class="text-uppercase grey--text text--darken-1">
                    Endereço do Local
                  </small>
                  <span>
                        {{application.address.street}}, {{application.address.number}} -
                        {{application.address.complement}} -
                        {{application.address.neighborhood}},
                        {{application.address.city}} - {{application.address.state}}
                        {{application.address.zip_code}}
                      </span>
                </v-layout>
              </v-card>
            </v-list>
          </v-card>
        </v-flex>

      </v-layout>
    </template>

    <template slot="content">

      <v-subheader class="subheader-1" v-if="application.intimations.length > 0">
        Intimações
      </v-subheader>

      <v-expansion-panel expand v-model="intimationPanels">
        <v-expansion-panel-content
          v-for="(intimation, indexIntimation) in application.intimations"
          :key="intimation.id"
        >
          <div slot="header">
            <v-layout row align-center justify-start>
              <v-flex xs6>
                <strong>{{intimation.reason}}</strong>
                <span
                  class="badge grey darken-2"
                  v-if="remainingDocumentsOnIntimation(intimation) !== 0"
                >
                  {{remainingDocumentsOnIntimation(intimation)}} restantes
                </span><br>
              <span>
                <span v-if="intimation.due_date != null">
                  <span v-if="isExpired(intimation.due_date)" class="red--text">
                    Vencido
                  </span>
                  <span v-else>
                    <v-icon>mdi-clock-fast mdi-18px</v-icon>
                    {{calcDueDate(intimation.due_date)}}
                  </span>
                </span>
              </span>

              </v-flex>
              <v-layout justify-space-around align-center>
                <v-flex xs7>
                  <v-progress-linear :value="progressDocumentsOnIntimation(intimation)"/>
                </v-flex>
                <strong class="grey--text text--darken-4">
                  {{Math.round(progressDocumentsOnIntimation(intimation))}}% ANEXADO
                </strong>
              </v-layout>
            </v-layout>
          </div>

          <v-card class="grey lighten-4 document-list">
            <v-card-text>
              <v-card two-line subheader v-for="(document,index) in intimation.documents"
                      :key="document.id">

                <v-layout
                  class="document-item"
                  align-start
                  justify-space-between
                  row>
                  <v-flex class="text-xs-center" xs1>
                    <v-icon class="mr-3">mdi-file mdi-24px</v-icon>
                  </v-flex>

                  <v-flex xs11>
                    <span class="font-weight-bold">
                      {{document.document_intimation.document_name}}
                      <p>{{ document.document_intimation.reason }}</p>
                    </span>

                    <v-layout row wrap>
                      <v-progress-circular :value="uploadPercentage"
                                            color="primary"
                                            :width="6"
                                            :size="32"
                                            v-if="isUploadingHere(document)"
                                            :key="document.id"/>
                      <v-btn small outline v-if="documentVersionCanBeShowed(document)"
                              @click="showDocument(document.last_document_version)"
                              color="primary">
                        <v-icon>mdi-eye</v-icon>
                        Visualizar
                      </v-btn>

                      <v-btn small color="red" outline
                              v-if="documentVersionCanBeDeleted(document)"
                              @click="deleteDocumentVersion(document)">
                        Remover
                      </v-btn>

                      <input
                        type="file"
                        :ref="`inputIntimation${indexIntimation}`"
                        accept="application/pdf"
                        @change="processFileIntimation($event,
                                                        document,
                                                        index,
                                                        indexIntimation)"
                        style="display:none"
                      >
                      <v-btn
                        class="px-2"
                        @click="clickedIntimation(indexIntimation, index)"
                        color="primary"
                        small
                        :disabled="isExpired(intimation.due_date)"
                        v-if="waitingToSent(document) && !isUploadingHere(document)
                          && !applicationInReview"
                      >
                        <v-icon left>mdi-cloud-upload</v-icon>
                        <span class="text">Selecionar</span>
                      </v-btn>

                      <v-btn
                        small
                        class="ml-0"
                        outline
                        color="primary"
                        @click="showDocument(document.last_document_version)"
                        v-if="checkDocumentStatus(document, 'disapproved_by_reviewer')"
                      >
                        <v-icon left>mdi-eye</v-icon>
                        Visualizar documento reprovado
                      </v-btn>
                    </v-layout>

                  </v-flex>
                </v-layout>

                <template v-if="checkDocumentChip(document)">
                  <v-divider class="mx-4"/>

                  <v-layout class="my-3">
                    <v-spacer/>
                    <v-flex xs11>  
                      <span class="badge"
                            v-bind:style="documentChipColor(document)">
                        {{documentChipText(document)}}
                      </span>

                      <span class="caption grey--text ml-2">
                        {{ document.last_document_version.updated_at | formatDateTime }}
                      </span>

                      <div class="my-2" v-if="checkDocumentStatus(document, 'disapproved_by_reviewer')">
                        <strong>Motivo da reprovação:</strong>
                        <span class="grey--text ml-2">{{document.last_document_version.refusal_reason}}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </template>

                <v-divider/>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>

      <v-subheader class="subheader-1">
        <v-layout justify-center column>
          <small class="badge green text-xs-center mt-2 mb-2">
            <download-file :application="application"/>
          </small>
          <small class="badge red text-xs-center">
            Todos os Documentos deverão ser enviados no formato <b>PDF</b> ou <b>KML</b>.
          </small>
          <small class="badge red mt-2 mb-2">
            <pdf-information-dialog></pdf-information-dialog>
          </small>
        </v-layout>
      </v-subheader>

      <v-subheader v-if="application.application_type.name == 'Defesa de Auto de Infração'" class="subheader-1">
        Auto de Infração
      </v-subheader>

      <infraction-notice-document
        v-if="application.application_type.name == 'Defesa de Auto de Infração'"
        :application="application">
      </infraction-notice-document>

      <v-subheader class="subheader-1">
        Documentos para Envio
      </v-subheader>

      <span v-if="isVisibleIBAMANorm">
        <v-layout justify-center column>
          <small class="badge green text-xs-center mt-2 mb-2 pa-3">
            De acordo com a Instrução Normativa IBAMA n° 21, de 24 de dezembro de
            2014, em observância dos arts. 35 e 36 da Lei nº 12.651, de 25 de maio de
            2012, as solicitações de emissão de autorizações de Supressão de
            Vegetação, deverão utilizar o
            <b @click="openWindowSinaflor()" style="cursor: pointer">
              <u>SINAFLOR</u>
            </b>.
          </small>
        </v-layout>
      </span>

      <v-expansion-panel expand v-model="panels" v-else>
        <v-expansion-panel-content v-if="basicDocuments.length > 0">
          <div slot="header">
            <v-layout row align-center justify-start>
              <v-flex xs6>
                <strong>Básicos</strong>
                <span class="badge grey darken-2" v-if="this.remainingBasicDocuments!==0 &&
                !applicationInReview">{{this.remainingBasicDocuments}} restantes</span>
              </v-flex>
              <v-layout justify-space-around align-center v-if="!applicationInReview">
                <v-flex xs7>
                  <v-progress-linear v-model="this.progressBasicRemaingDocuments"/>
                </v-flex>
                <strong class="grey--text text--darken-4">
                  {{Math.round(this.progressBasicRemaingDocuments)}}% ANEXADO
                </strong>
              </v-layout>
            </v-layout>
          </div>

          <v-card class="grey lighten-4 document-list">
            <v-card-text>
              <v-card two-line subheader v-for="(documentOptional,index) in basicDocuments"
                      :key="documentOptional.id">

                <v-layout
                  class="document-item"
                  align-start
                  justify-space-between
                  row>
                  <v-flex class="text-xs-center" xs1>
                    <v-icon class="mr-3">mdi-file mdi-24px</v-icon>
                  </v-flex>

                  <v-flex xs11>
                    <span class="font-weight-bold">{{documentOptional.document_type.name}}</span>

                    <v-layout row wrap>
                      <v-progress-circular :value="uploadPercentage"
                                            color="primary"
                                            :width="6"
                                            :size="32"
                                            v-if="isUploadingHere(documentOptional)"
                                            :key="documentOptional.id"/>
                      <v-btn small outline v-if="documentVersionCanBeShowed(documentOptional)"
                              @click="showDocument(documentOptional.last_document_version)"
                              color="primary">
                        <v-icon>mdi-eye</v-icon>
                        Visualizar
                      </v-btn>

                      <v-btn small color="red" outline
                              v-if="documentVersionCanBeDeleted(documentOptional)"
                              @click="deleteDocumentVersion(documentOptional)">
                        Remover
                      </v-btn>

                      <input
                        type="file"
                        ref="input"
                        accept="application/pdf"
                        @change="processFile($event,documentOptional,index)"
                        style="display: none"
                      >
                      <v-btn
                        class="px-2"
                        @click="clicked(index)"
                        color="primary"
                        small
                        v-if="waitingToSent(documentOptional) &&
                              !isUploadingHere(documentOptional) &&
                              !applicationInReview"
                      >
                        <v-icon left>mdi-cloud-upload</v-icon>
                        <span class="text">Selecionar</span>
                      </v-btn>

                      <v-btn
                        small
                        class="ml-0"
                        outline
                        color="primary"
                        @click="showDocument(documentOptional.last_document_version)"
                        v-if="checkDocumentStatus(documentOptional, 'disapproved_by_reviewer')"
                      >
                        <v-icon left>mdi-eye</v-icon>
                        Visualizar documento reprovado
                      </v-btn>
                    </v-layout>

                  </v-flex>
                </v-layout>

                <template v-if="checkDocumentChip(documentOptional)">
                  <v-divider class="mx-4"/>

                  <v-layout class="my-3">
                    <v-spacer/>
                    <v-flex xs11>  
                      <span class="badge"
                            v-bind:style="documentChipColor(documentOptional)">
                        {{documentChipText(documentOptional)}}
                      </span>

                      <span class="caption grey--text ml-2">
                        {{ documentOptional.last_document_version.updated_at | formatDateTime }}
                      </span>

                      <div class="my-2" v-if="checkDocumentStatus(documentOptional, 'disapproved_by_reviewer')">
                        <strong>Motivo da reprovação:</strong>
                        <span class="grey--text ml-2">{{documentOptional.last_document_version.refusal_reason}}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </template>

                <v-divider/>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content v-if="specificDocuments.length > 0">
          <div slot="header">
            <v-layout row align-center justify-start>
              <v-flex xs6>
                <strong>Específicos</strong>
                <span class="badge grey darken-2" v-if="this.remainingSpecificDocuments!==0 &&
                !applicationInReview">{{this.remainingSpecificDocuments}} restantes</span>
              </v-flex>
              <v-layout justify-space-around align-center v-if="!applicationInReview">
                <v-flex xs7>
                  <v-progress-linear v-model="this.progressSpecificDocuments"/>
                </v-flex>
                <strong class="grey--text text--darken-4">
                  {{Math.round(this.progressSpecificDocuments)}}% ANEXADO
                </strong>
              </v-layout>
            </v-layout>
          </div>

          <v-card class="grey lighten-4 document-list">
            <v-card-text>
              <v-card two-line subheader v-for="(documentOptional,index) in specificDocuments"
                      :key="documentOptional.id">
                <v-layout
                  class="document-item"
                  align-start
                  justify-space-between
                  row>
                  <v-flex class="text-xs-center" xs1>
                    <v-icon class="mr-3">mdi-file mdi-24px</v-icon>
                  </v-flex>

                  <v-flex xs11>
                    <span class="font-weight-bold">{{documentOptional.document_type.name}}</span>

                    <v-layout row wrap>
                      <v-progress-circular :value="uploadPercentage"
                                            color="primary"
                                            :width="6"
                                            :size="32"
                                            v-if="isUploadingHere(documentOptional)"
                                            :key="documentOptional.id"/>
                      <v-btn small outline v-if="documentVersionCanBeShowed(documentOptional)"
                              @click="showDocument(documentOptional.last_document_version)"
                              color="primary">
                        <v-icon>mdi-eye</v-icon>
                        Visualizar
                      </v-btn>

                      <v-btn small color="red" outline
                              v-if="documentVersionCanBeDeleted(documentOptional)"
                              @click="deleteDocumentVersion(documentOptional)">
                        Remover
                      </v-btn>

                      <input
                        type="file"
                        ref="inputOptional"
                        accept="application/pdf"
                        @change="processFileOptional($event,documentOptional,index)"
                        style="display: none"
                      >
                      <v-btn
                        class="px-2"
                        @click="clickedOptional(index)"
                        color="primary"
                        small
                        v-if="waitingToSent(documentOptional) &&
                              !isUploadingHere(documentOptional) &&
                              !applicationInReview"
                      >
                        <v-icon left>mdi-cloud-upload</v-icon>
                        <span class="text">Selecionar</span>
                      </v-btn>

                      <v-btn
                        small
                        class="ml-0"
                        outline
                        color="primary"
                        @click="showDocument(documentOptional.last_document_version)"
                        v-if="checkDocumentStatus(documentOptional, 'disapproved_by_reviewer')"
                      >
                        <v-icon left>mdi-eye</v-icon>
                        Visualizar documento reprovado
                      </v-btn>
                    </v-layout>

                  </v-flex>
                </v-layout>

                <template v-if="checkDocumentChip(documentOptional)">
                  <v-divider class="mx-4"/>

                  <v-layout class="my-3">
                    <v-spacer/>
                    <v-flex xs11>
                      <span class="badge"
                            v-bind:style="documentChipColor(documentOptional)">
                        {{documentChipText(documentOptional)}}
                      </span>

                      <span class="caption grey--text ml-2">
                        {{ documentOptional.last_document_version.updated_at | formatDateTime }}
                      </span>

                      <div class="my-2" v-if="checkDocumentStatus(documentOptional, 'disapproved_by_reviewer')">
                        <strong>Motivo da reprovação:</strong>
                        <span class="grey--text ml-2">{{documentOptional.last_document_version.refusal_reason}}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </template>

                <v-divider/>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content v-if="technicalDocuments.length > 0">
          <div slot="header">
            <v-layout row align-center justify-start>
              <v-flex xs6>
                <strong>Técnicos</strong>
                <span class="badge grey darken-2" v-if="this.remainingTechnicalDocuments!==0 &&
                !applicationInReview">{{this.remainingTechnicalDocuments}} restantes</span>
              </v-flex>
              <v-layout justify-space-around align-center v-if="!applicationInReview">
                <v-flex xs7>
                  <v-progress-linear v-model="this.progressTechnicalDocuments"/>
                </v-flex>
                <strong class="grey--text text--darken-4">
                  {{Math.round(this.progressTechnicalDocuments)}}% ANEXADO
                </strong>
              </v-layout>
            </v-layout>
          </div>
          <v-card class="grey lighten-4 document-list">
            <v-card-text>
              <v-card two-line subheader v-for="(documentOptional,index) in technicalDocuments"
                      :key="documentOptional.id">
                
                <v-layout
                  class="document-item"
                  align-start
                  justify-space-between
                  row>
                  <v-flex class="text-xs-center" xs1>
                    <v-icon class="mr-3">mdi-file mdi-24px</v-icon>
                  </v-flex>

                  <v-flex xs11>
                    <span class="font-weight-bold">{{documentOptional.document_type.name}}</span>

                    <v-layout row wrap>
                      <v-progress-circular :value="uploadPercentage"
                                            color="primary"
                                            :width="6"
                                            :size="32"
                                            v-if="isUploadingHere(documentOptional)"
                                            :key="documentOptional.id"/>
                      <v-btn small outline v-if="documentVersionCanBeShowed(documentOptional)"
                              @click="showDocument(documentOptional.last_document_version)"
                              color="primary">
                        <v-icon>mdi-eye</v-icon>
                        Visualizar
                      </v-btn>

                      <v-btn small color="red" outline
                              v-if="documentVersionCanBeDeleted(documentOptional)"
                              @click="deleteDocumentVersion(documentOptional)">
                        Remover
                      </v-btn>

                      <input
                        type="file"
                        ref="inputTechnic"
                        accept="application/pdf"
                        @change="processFileTechnic($event,documentOptional,index)"
                        style="display: none"
                      >
                      <v-btn
                        class="px-2"
                        @click="clickedTechnic(index)"
                        color="primary"
                        small
                        v-if="waitingToSent(documentOptional) &&
                              !isUploadingHere(documentOptional) &&
                              !applicationInReview"
                      >
                        <v-icon left>mdi-cloud-upload</v-icon>
                        <span class="text">Selecionar</span>
                      </v-btn>

                      <v-btn
                        small
                        class="ml-0"
                        outline
                        color="primary"
                        @click="showDocument(documentOptional.last_document_version)"
                        v-if="checkDocumentStatus(documentOptional, 'disapproved_by_reviewer')"
                      >
                        <v-icon left>mdi-eye</v-icon>
                        Visualizar documento reprovado
                      </v-btn>
                    </v-layout>

                  </v-flex>
                </v-layout>

                <template v-if="checkDocumentChip(documentOptional)">
                  <v-divider class="mx-4"/>

                  <v-layout class="my-3">
                    <v-spacer/>
                    <v-flex xs11>  
                      <span class="badge"
                            v-bind:style="documentChipColor(documentOptional)">
                        {{documentChipText(documentOptional)}}
                      </span>

                      <span class="caption grey--text ml-2">
                        {{ documentOptional.last_document_version.updated_at | formatDateTime }}
                      </span>

                      <div class="my-2" v-if="checkDocumentStatus(documentOptional, 'disapproved_by_reviewer')">
                        <strong>Motivo da reprovação:</strong>
                        <span class="grey--text ml-2">{{documentOptional.last_document_version.refusal_reason}}</span>
                      </div>
                    </v-flex>
                  </v-layout>
                </template>

                <v-divider/>
              </v-card>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </template>

  </show-layout>
</template>

<script>
import ShowLayout from '@/layouts/ShowLayout';
import BoletoCard from '@/components/application/BoletoCard';
import AS from '@/services/AuthenticationService';
import axios from 'axios';
import colors from 'vuetify/es5/util/colors';
import moment from 'moment';
import PdfInformationDialog from '@/components/application/show/PdfInformationDialog';
import DownloadFile from '@/components/application/list/approved_application/DownloadFile';
import InfractionNoticeDocument from '@/components/application/show/InfractionNoticeDocument';
import QualificationFormDialog from '@/components/application/show/QualificationFormDialog';

export default {
  name: 'ShowApplication',
  components: {
    PdfInformationDialog,
    ShowLayout,
    BoletoCard,
    DownloadFile,
    InfractionNoticeDocument,
    QualificationFormDialog
  },
  props: ['id'],
  mounted() {
    this.$store.dispatch('getCurrentUser');
    this.$store.dispatch('setLoadingDialog', true);
    this.$store.dispatch('fetchApplication', this.id)
      .catch((err) => {
        this.onErrorFetchApplication(err);
      })
      .finally(() => {
        this.isLoading = false;
        this.$store.dispatch('setLoadingDialog', false);
      });
  },
  data() {
    return {
      isLoading: true,
      isUploading: false,
      moment,
      uploadPercentage: 0,
      documentsChips: [
        { background: colors.blue.darken2, color: 'white' },
        { background: colors.red.darken2, color: 'white' },
        { background: colors.green.base, color: 'white' },
      ],
      panels: [true, true],
      intimationPanels: [true],
      showQualificationForm: false,
    };
  },
  computed: {
    applicationChipColor() {
      if (this.application.status === 'waiting_to_be_sent') {
        return { background: colors.grey.darken2, color: 'white' };
      } else if (this.application.status === 'waiting_for_review' || this.application.status === 'in_review') {
        return { background: colors.amber.base, color: 'white' };
      } else if (this.application.status === 'pending' || this.application.status === 'intimated') {
        return { background: colors.red.base, color: 'white' };
      }
      return { background: colors.green.base, color: 'white' };
    },
    applicationChipText() {
      if (this.application.status === 'waiting_to_be_sent') {
        return 'Aguardando o envio';
      } else if (this.application.status === 'waiting_for_review') {
        return 'Aguardando análise';
      } else if (this.application.status === 'in_review') {
        return 'Em análise';
      } else if (this.application.status === 'pending') {
        return 'Pendente';
      } else if (this.application.status === 'intimated') {
        return 'Intimado';
      }
      return 'Aprovado';
    },
    remainingBasicDocuments() {
      const documents = this.$store.getters.documents;
      return documents.reduce((prev, elem) => {
        if (((elem.last_document_version == null) ||
          (elem.last_document_version.status === 'waiting_to_be_sent' || elem.last_document_version.status === 'disapproved_by_reviewer')) &&
          (elem.document_type.category === 'basic')) {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    remainingSpecificDocuments() {
      const documents = this.$store.getters.documents;
      return documents.reduce((prev, elem) => {
        if (((elem.last_document_version == null) ||
          (elem.last_document_version.status === 'waiting_to_be_sent' || elem.last_document_version.status === 'disapproved_by_reviewer')) &&
          (elem.document_type.category === 'specific')) {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    remainingTechnicalDocuments() {
      const documents = this.$store.getters.documents;
      return documents.reduce((prev, elem) => {
        if (((elem.last_document_version == null) ||
          (elem.last_document_version.status === 'waiting_to_be_sent' || elem.last_document_version.status === 'disapproved_by_reviewer')) &&
          (elem.document_type.category === 'technic')) {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    application() {
      return this.$store.getters.application;
    },
    basicDocuments() {
      return this.$store.getters.documents.filter(a => a.document_type.category === 'basic');
    },
    specificDocuments() {
      return this.$store.getters.documents.filter(a => a.document_type.category === 'specific');
    },
    technicalDocuments() {
      return this.$store.getters.documents.filter(a => a.document_type.category === 'technic');
    },
    progressBasicRemaingDocuments() {
      if (this.remainingBasicDocuments === 0) {
        return 100;
      }
      return (1 - (this.remainingBasicDocuments / this.basicDocuments.length)) * 100;
    },
    progressSpecificDocuments() {
      if (this.remainingSpecificDocuments === 0) {
        return 100;
      }
      return (1 - (this.remainingSpecificDocuments / this.specificDocuments.length)) * 100;
    },
    progressTechnicalDocuments() {
      if (this.remainingTechnicalDocuments === 0) {
        return 100;
      }
      return (1 - (this.remainingTechnicalDocuments / this.technicalDocuments.length)) * 100;
    },
    applicationInReview() {
      return (this.application.status === 'in_review' ||
        this.application.status === 'waiting_for_review' ||
        this.application.status === 'done');
    },
    isPaymentSlipPaid() {
      try {
        return this.application.payment_slips.length > 0 && this.application.payment_slips[0].payment_status;
      } catch (error) {
        return false;
      }
    },
    isVisibleIBAMANorm() {
      try {
        return this.isPaymentSlipPaid && this.application.typology.typology_id === 453;
      } catch (error) {
        return false;
      }
    },
  },
  methods: {
    openQualificationForm() {
      // console.log('Opening qualification form dialog, form data:', this.application.qualification_form);
      this.showQualificationForm = true;
    },
    calcDueDate(dueDateIntimation) {
      const dueDate = new Date(dueDateIntimation);
      const timeDiff = dueDate.getTime() - new Date().getTime();
      const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      return `Prazo: ${diffDays} dias`;
    },
    getPaymentSlip({ complementary }) {
      return this.application.payment_slips.find(payment_slip => payment_slip.complementary == complementary);
    },
    isExpired(dueDateIntimation) {
      if (dueDateIntimation == null) {
        return false;
      }
      const dueDate = new Date(dueDateIntimation);
      return new Date() > dueDate;
    },
    checkDocumentChip(document) {
      if (document.last_document_version == null) {
        return false;
      } else if (document.last_document_version.status === 'disapproved_by_reviewer'
        || document.last_document_version.status === 'disapproved_by_creator'
        || document.last_document_version.status === 'approved') {
        return true;
      }
      return false;
    },
    checkDocumentStatus(document, status) {
      return document.last_document_version
          && document.last_document_version.status === status;
    },
    documentChipColor(document) {
      if (document.last_document_version == null
        || document.last_document_version.status === 'waiting_to_be_sent'
        || document.last_document_version.status === 'awaiting_review') {
        return { background: colors.blue.darken2, color: 'white' };
      } else if (document.last_document_version.status === 'disapproved_by_reviewer' ||
        document.last_document_version.status === 'disapproved_by_creator') {
        return { background: colors.red.base, color: 'white' };
      }
      return { background: colors.green.base, color: 'white' };
    },
    documentChipText(document) {
      if (document.last_document_version == null ||
        document.last_document_version.status === 'waiting_to_be_sent') {
        return 'Aguardando Envio';
      } else if (document.last_document_version.status === 'awaiting_review') {
        return 'Enviado';
      } else if (document.last_document_version.status === 'disapproved_by_reviewer' ||
        document.last_document_version.status === 'disapproved_by_creator') {
        return 'Reprovado';
      }
      return 'Aprovado';
    },
    isUploadingHere(document) {
      return document.id === this.isUploading;
    },
    documentVersionCanBeDeleted(document) {
      if (document.last_document_version == null) {
        return false;
      } else if ((this.application.status === 'waiting_to_be_sent' || this.application.status === 'pending') && (document.last_document_version.status === 'awaiting_review')) {
        return true;
      }
      return false;
    },
    waitingToSent(document) {
      return document.last_document_version == null || document.last_document_version.status === 'waiting_to_be_sent' ||
        document.last_document_version.status === 'disapproved_by_reviewer';
    },
    documentVersionCanBeShowed(document) {
      return document.last_document_version != null && document.last_document_version.status !== 'waiting_to_be_sent'
        && document.last_document_version.status !== 'disapproved_by_reviewer';
    },
    clicked(index) {
      this.$refs.input[index].click();
    },
    clickedOptional(index) {
      this.$refs.inputOptional[index].click();
    },
    clickedTechnic(index) {
      this.$refs.inputTechnic[index].click();
    },
    clickedIntimation(indexIntimation, index) {
      this.$refs[`inputIntimation${indexIntimation}`][index].click();
    },
    processFile(event, document, index) {
      this.isUploading = document.id;
      const file = event.target.files[0];
      this.$refs.input[index].value = null;

      const headers = AS.getDefaultHeaders();
      headers.headers['Content-Type'] = 'multipart/form-data';

      const formData = new FormData();

      formData.append('application[document]', file);
      formData.append('application[document_type_id]', document.document_type.id);
      formData.append('id', document.id);

      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.uploadPercentage = percentCompleted;
        },
        headers: headers.headers,
      };

      axios.post(`requerimentos/${this.application.id}/documents`, formData, config)
        .then((response) => {
          if (response.data.document_status === 'intimated') {
            this.$store.dispatch('sendNewDocumentVersionIntimated', {
              document: response.data,
              intimations: this.application.intimations,
            });
          } else {
            this.$store.dispatch('sendNewDocumentVersion', {
              document: response.data,
              documents: this.application.documents,
            });
          }
          this.isUploading = false;
          this.uploadPercentage = 0;
        })
        .catch((err) => {
          alert(err.response.data.join('\n'));
        })
        .finally(() => {
          this.isUploading = false;
          this.uploadPercentage = 0;
        });
    },
    processFileIntimation(event, document, index, indexIntimation) {
      this.isUploading = document.id;
      const file = event.target.files[0];
      this.$refs[`inputIntimation${indexIntimation}`][index].value = null;

      const headers = AS.getDefaultHeaders();
      headers.headers['Content-Type'] = 'multipart/form-data';

      const formData = new FormData();

      formData.append('application[document]', file);
      formData.append('application[document_type_id]', document.document_type.id);
      formData.append('id', document.id);

      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.uploadPercentage = percentCompleted;
        },
        headers: headers.headers,
      };

      axios.post(`requerimentos/${this.application.id}/documents`, formData, config)
        .then((response) => {
          if (response.data.document_status === 'intimated') {
            this.$store.dispatch('sendNewDocumentVersionIntimated', {
              document: response.data,
              intimations: this.application.intimations,
            });
          } else {
            this.$store.dispatch('sendNewDocumentVersion', {
              document: response.data,
              documents: this.application.documents,
            });
          }
          this.isUploading = false;
          this.uploadPercentage = 0;
        })
        .catch((err) => {
          alert(err.response.data.join('\n'));
        })
        .finally(() => {
          this.isUploading = false;
          this.uploadPercentage = 0;
        });
    },
    processFileOptional(event, document, index) {
      this.isUploading = document.id;
      const file = event.target.files[0];
      this.$refs.inputOptional[index].value = null;

      const headers = AS.getDefaultHeaders();
      headers.headers['Content-Type'] = 'multipart/form-data';

      const formData = new FormData();

      formData.append('application[document]', file);
      formData.append('application[document_type_id]', document.document_type.id);
      formData.append('id', document.id);

      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.uploadPercentage = percentCompleted;
        },
        headers: headers.headers,
      };

      axios.post(`requerimentos/${this.application.id}/documents`, formData, config)
        .then((response) => {
          this.$store.dispatch('sendNewDocumentVersion', {
            document: response.data,
            documents: this.application.documents,
          });
        })
        .catch((err) => {
          alert(err.response.data.join('\n'));
        })
        .finally(() => {
          this.isUploading = false;
          this.uploadPercentage = 0;
        });
    },
    processFileTechnic(event, document, index) {
      this.isUploading = document.id;
      const file = event.target.files[0];
      this.$refs.inputTechnic[index].value = null;

      const headers = AS.getDefaultHeaders();
      headers.headers['Content-Type'] = 'multipart/form-data';

      const formData = new FormData();

      formData.append('application[document]', file);
      formData.append('application[document_type_id]', document.document_type.id);
      formData.append('id', document.id);

      const config = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          this.uploadPercentage = percentCompleted;
        },
        headers: headers.headers,
      };

      axios.post(`requerimentos/${this.application.id}/documents`, formData, config)
        .then((response) => {
          this.$store.dispatch('sendNewDocumentVersion', {
            document: response.data,
            documents: this.application.documents,
          });
        })
        .finally(() => {
          this.isUploading = false;
          this.uploadPercentage = 0;
        });
    },
    showDocument(lastVersion) {
      window.open(lastVersion.document_path.url);
    },
    deleteDocumentVersion(document) {
      const config = AS.getDefaultHeaders();
      config.headers['Content-Type'] = 'application/json';
      axios.put(`requerimentos/${this.application.id}/documents/${document.id}/delete_version`, null, config)
        .then((response) => {
          this.$store.dispatch('sendNewDocumentVersion', {
            document: response.data,
            documents: this.application.documents,
          });
        });
    },
    sendApplicationToReview() {
      this.$store.dispatch('setLoadingDialog', true);
      this.$store.dispatch('sendApplicationToReview', this.application)
        .then(() => {
          this.$swal({
            type: 'success',
            titleText: 'Requerimento enviado!',
          });
          this.$router.push('/');
        })
        .catch(() => {
          this.$swal({
            type: 'error',
            title: 'Erro',
            text: 'Erro desconhecido.',
          });
        })
        .finally(() => {
          this.$store.dispatch('setLoadingDialog', false);
        });
    },
    remainingDocumentsOnIntimation(intimation) {
      return intimation.documents.reduce((prev, elem) => {
        if (((elem.last_document_version == null) ||
          (elem.last_document_version.status === 'waiting_to_be_sent' || elem.last_document_version.status === 'disapproved_by_reviewer'))) {
          return prev + 1;
        }
        return prev;
      }, 0);
    },
    progressDocumentsOnIntimation(intimation) {
      if (this.remainingDocumentsOnIntimation(intimation) === 0) {
        return 100;
      }
      return (1 - (this.remainingDocumentsOnIntimation(intimation) /
        intimation.documents.length)) * 100;
    },
    canSendApplicationToReview() {
      let remainingDocumentsOnIntimations = 0;
      let expiredIntimations = 0;
      this.application.intimations.forEach((intimation) => {
        remainingDocumentsOnIntimations += this.remainingDocumentsOnIntimation(intimation);
        expiredIntimations += this.isExpired(intimation.due_date);
      });

      return (this.remainingBasicDocuments === 0 &&
        this.remainingSpecificDocuments === 0 &&
        this.remainingTechnicalDocuments === 0 &&
        remainingDocumentsOnIntimations === 0 &&
        expiredIntimations === 0 &&
        (this.application.status === 'waiting_to_be_sent' || this.application.status === 'pending' || this.application.status === 'intimated'));
    },
    onErrorFetchApplication(err) {
      if (err.response.status === 403) {
        this.$swal({
          type: 'error',
          titleText: 'Você não tem acesso a esse requerimento!',
        });
        this.$router.push('/');
      } else if (err.response.status === 404) {
        this.$swal({
          type: 'error',
          titleText: 'Esse requerimento não foi encontrado!',
        });
        this.$router.push('/');
      }
    },
    openWindowSinaflor() {
      window.open('http://www.ibama.gov.br/sistemas/sinaflor', '_blank');
    },
  },
};
</script>
